// import React from "react";
// import { Check, UserCheck } from "lucide-react";
// import "../../styles/cmyuva.css";

// const CmYuvaEligibility = () => {
//   const eligibilityItems = [
//     "Age between 18-35 years",
//     "Basic understanding of digital media or creative field",
//     "Passion for storytelling and creative expression",
//     "Committed to 6-month program participation",
//     "Ability to work on real-world projects",
//   ];

//   return (
//     <section className="cmyuva_eligibility_section py-5 position-relative overflow-hidden">
//       <div className="container py-4">
//         <div className="row align-items-center g-5">

//           {/* Left Side: Visual/Context */}
//           <div className="col-lg-5" data-aos="fade-right">
//<div className="position-relative p-3">
//                {/* Decorative offset border - fixed z-index */}
//                <div className="position-absolute top-0 start-0 w-100 h-100 border border-2 border-danger rounded-4 mt-2 ms-2" style={{zIndex: 0}}></div>

//                {/* Main Card */}
//               <div className="bg-dark text-white p-5 rounded-4 shadow-lg position-relative" style={{zIndex: 1}}>
//                 <div className="position-absolute top-0 end-0 opacity-10 p-3">
//                   <UserCheck size={120} />
//                 </div>
//                 <h3 className="display-6 fw-bold mb-3">Who Can Apply?</h3>
//                 <p className="opacity-75 mb-4">
//                   We are looking for passionate individuals ready to transform India's creative ecosystem.
//                 </p>
//                 <button className="btn btn-light rounded-pill px-4 fw-bold text-dark">
//                   Check Status
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Right Side: Checklist */}
//           <div className="col-lg-7" data-aos="fade-left">
//             <div className="ps-lg-5">
//               <h2 className="cmyuva_section_title mb-4">Eligibilty Criteria</h2>
//               <div className="d-flex flex-column gap-3">
//                 {eligibilityItems.map((item, idx) => (
//                   <div key={idx} className="d-flex align-items-center p-3 bg-white rounded-3 shadow-sm border-start border-4 border-danger hover-lift transition-all">
//                     <div className="flex-shrink-0 me-3 bg-danger text-white rounded-circle p-1 d-flex">
//                       <Check size={16} />
//                     </div>
//                     <span className="fw-medium text-dark">{item}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default CmYuvaEligibility;

import React from "react";
import eligibility_image from "../../assets/images/png/gig-media-collage.jpg";
import { Check, UserCheck, Clapperboard, BadgeCheck } from "lucide-react";
import "../../styles/cmyuva.css";

const CmYuvaServices = () => {
  const eligibilityItems = [
    "The applicant should be a permanent resident of Uttar Pradesh.",
    "The applicant’s age should be between 21 to 40 years.",
    "The applicant should have passed at least Class 08",
  ];

  const services = [
    "Studio service projects (Editing, VFX, Animation, Game Development, Graphics)",
    "Digital marketing retainers for local businesses and MSMEs",
    "Podcasts and studio shoots",
    "Outsourced work from agencies and brands via HKI Media & GigMedia",
    "Freelance and project-based execution for ads, social media, content creation, films, music videos, events & weddings)",
  ];

  return (
    <section className="cmyuva_eligibility_section bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] py-5 position-relative overflow-hidden">
      <div className="container py-4">
        <div className="row align-items-start justify-content-center g-5">
          <div
            className="col-12 text-center mb-1"
            data-aos="fade-up"
            data-aos-offset="120"
          >
            <h2 className="cmyuva_section_title">
              HKI Digital Media Studio Services
            </h2>
          </div>
          <div className="row justify-content-center align-items-stretch">
            {/* LEFT */}
            <div
              className="col-lg-6 d-flex eligibility_image_wrapper"
              style={{ zIndex: 5, position: "relative" }}
            >
              <img
                loading="lazy"
                decoding="async"
                src={eligibility_image}
                className="eligibility_image h-100"
                alt="cm yuva eligibility image"
              />
            </div>
            {/* RIGHT */}
            <div
              data-aos="fade-right"
              className="col-lg-6 d-flex justify-content-center align-items-stretch"
              data-aos-offset="60"
            >
              {/* Decorative offset border - fixed z-index */}
              <div className="position-relative d-flex p-3">
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 border border-2 border-danger rounded-4 mt-2 ms-2"
                  style={{ zIndex: 0 }}
                ></div>
                {/* Main Card */}
                <div
                  className="d-flex align-items-stretch text-white p-5 rounded-4 shadow-lg position-relative"
                  style={{ zIndex: 1, backgroundColor: "#0f172a" }}
                >
                  <div className="position-absolute top-0 end-0 opacity-10 p-3">
                    <Clapperboard size={120} />
                  </div>
                  <div className="d-flex flex-column justify-content-center">
                    {services.map((service) => (
                      <div
                        key={service}
                        className="d-flex text-start align-items-center"
                        style={{
                          maxWidth: "90%",
                          opacity: "80%",
                        }}
                      >
                        <span
                          style={{
                            padding: "8px",
                            justifyContent: "center",
                          }}
                        >
                          {/* <MessageCircleQuestionMark size={24} /> */}
                          <span
                            className="number_icon"
                            style={{ fontWeight: "" }}
                          >
                            <BadgeCheck size={52} />
                          </span>
                        </span>
                        <div className="py-2 py-md-0">
                          <h6>{service}</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmYuvaServices;
